.surveyNotificationCard {
	@apply yst-mb-4 yst-border-primary-200 yst-border yst-relative yst-p-4 #{!important};

	.closeButton {
		@apply yst-w-6 yst-h-6 yst-absolute yst-right-4 yst-top-4 yst-cursor-pointer yst-text-slate-400;

		&:hover,
		&:focus {
			@apply yst-text-slate-600;
		}
	}

	.container {
		@apply yst-flex yst-gap-3 yst-m-0 #{!important};

		.icon {
			width: 17px;
			height: 17px;
		}

		.title {
			@apply yst-text-base yst-mb-2 #{!important};
		}

		.content {
			@apply yst-grow yst-max-w-5xl yst-space-y-2;
		}
	}

	p {
		@apply yst-max-w-[640px] yst-mb-2 #{!important};
	}

	.buttonContainer {
		@apply yst-flex yst-gap-2;

		button, a {
			padding: 6px 8px 6px 10px;
		}
	}

	.externalIcon {
		@apply yst-w-4 yst-h-4 yst-ml-1;
	}
}
